module.exports = __webpack_public_path__ + "static/media/Creation-Covenant-Christ.8e6c3f51.png";